import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { conveniosNNXPostPracticas } from "../../../actions/contrataciones/contratacionesConvenios";

export const ConveniosNNXPracticas = (props) => {
  const dispatch = useDispatch();
  const { nnxPracticasTabla } = useSelector((state) => state.contratacionesConvenios);
  const { dataContrato } = useSelector((state) => state.contrataciones);

  const submitHandler = (e) => {
    e.preventDefault();

    const valorizacionesFormateadas = nnxPracticasTabla.map(
      (valorizacion, index) => {
        return {
          ...valorizacion,
          valor: parseFloat(e.target[`valor-${index}`].value)
        };
      }
    );

    const dataFormateada = {
      valorizaciones: valorizacionesFormateadas,
      idUsuarioAlta: null,
      idEfectorFacturacion: dataContrato.idEfectorFacturacion,
    };

    dispatch(
      conveniosNNXPostPracticas(
        dataFormateada,
        props.setShowTable,
        props.resetForm
      )
    );
  };

  return (
    <React.Fragment>
      <ValidatorForm onSubmit={submitHandler}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "10%" }}>Codigo Practica</TableCell>
              <TableCell style={{ width: "50%" }}>Nombre Practica</TableCell>
              <TableCell style={{ width: "20%" }}>Valor</TableCell>
              <TableCell style={{ width: "20%" }}>
                Fecha Inicio Vigencia
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {nnxPracticasTabla?.map((practica, index) => {
              return (
                <TableRow key={index} practica={`practica-${index}`}>
                  <TableCell>{practica.codigoPractica}</TableCell>
                  <TableCell>{practica.nombrePractica}</TableCell>
                  <TableCell>
                    <TextValidator
                      margin="normal"
                      fullWidth
                      autoComplete="off"
                      name={`valor-${index}`}
                      defaultValue={practica.valor}
                      validators={["isFloat"]}
                      errorMessages={["Solo numeros"]}
                    />
                  </TableCell>
                  <TableCell>
                    {new Date(
                      practica.fechaInicioVigencia
                    ).toLocaleDateString()}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Button
          variant="contained"
          color="primary"
          style={{ margin: "1.5rem", float: "right", marginTop: "2rem" }}
          type="submit"
        >
          Confirmar
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ margin: "1.5rem", float: "right", marginTop: "2rem" }}
          onClick={() => {
            props.setShowTable(false);
          }}
        >
          Cancelar
        </Button>
      </ValidatorForm>
    </React.Fragment>
  );
};
